// extracted by mini-css-extract-plugin
export default {"submitButton":"fteo8Bkk7DpuAbyr9bgq","box":"D4ShXSwGkCu7_yQvlRK0","boxBottom":"HtXdKw81qG3e5v82B7Fr"};